import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/NatalieWoodrum/subs.vtt';
import poster from '@/static/assets/reviews/NatalieWoodrum/video.jpg';

export const NatalieWoodrum: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet],
  reviewerName: 'Natalie',
  videoUrl: `${ASSETS_URL}/pet/NatalieWoodrum.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
